import { Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/Login";
import { SpeechToTextPage } from "./pages/SpeechToText";
import { HomePage } from "./pages/Home";
import { ProfilePage } from "./pages/Profile";
import { SettingsPage } from "./pages/Settings";
import { ProtectedLayout } from "./components/ProtectedLayout";
import { HomeLayout } from "./components/HomeLayout";
import "./styles.css";
import { PackagePage } from "./pages/Package";
import { PaymentPage } from "./pages/Payment";
import { FinalPage } from "./pages/Final";

export default function App() {
  return (
    <Routes>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/speechtotext" element={<SpeechToTextPage />} />
      </Route>

      <Route path="/dashboard" element={<ProtectedLayout />}>
        <Route path="profile" element={<ProfilePage />} />
        <Route path="package" element={<PackagePage />} />
        <Route path="payment" element={<PaymentPage />} />
        <Route path="final" element={<FinalPage />} />
        {/*<Route path="settings" element={<SettingsPage />} />*/}
      </Route>
    </Routes>
  );
}
